import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

// Expected auth data from the attendant site needed so the tRPC service knows who we are.
export interface CookieData {
  cookie: {
    name: string;
    value: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly COOKIE_STORAGE_KEY = 'attendant_auth_cookie';

  // Stores the cookie auth data that was retrieved from the attendant site.
  cookieData: CookieData | null = null;
  public isAuthenticatedObservable = new BehaviorSubject(false);
  
  constructor(private httpClient: HttpClient) {
    // Try to load cookie from localStorage on service initialization
    this.loadCookieFromStorage();
  }

  getCookie() {
    // const fn = 'getCookie';
    // console.log(`${fn}: entry`);

    // This is the location to the file which will return out auth cookie
    let path = '';

    // If we weren't given a path in the config then assume the default
    if(environment.SITE_AUTH_HANDLER_URI === '') {
      path = `authtoken.php?return-json=1`;
    } else {
      path = `${environment.SITE_AUTH_HANDLER_URI}?return-json=1`;
    }

    const url = environment.SITE_URL_LOCAL + path;

    // console.info('Send GET to ' + url);

    return this.httpClient.get<any>(url);

  }

  /**
   * Save cookie data to localStorage for persistence across page refreshes
   */
  saveCookieToStorage(cookieData: CookieData): void {
    try {
      localStorage.setItem(this.COOKIE_STORAGE_KEY, JSON.stringify(cookieData));
      this.cookieData = cookieData;
      console.log('Cookie saved to localStorage:', cookieData.cookie.name);
    } catch (error) {
      console.error('Failed to save cookie to localStorage:', error);
    }
  }

  /**
   * Load cookie data from localStorage
   */
  loadCookieFromStorage(): CookieData | null {
    try {
      const storedCookie = localStorage.getItem(this.COOKIE_STORAGE_KEY);
      if (storedCookie) {
        this.cookieData = JSON.parse(storedCookie);
        console.log('Cookie loaded from localStorage:', this.cookieData?.cookie.name);
        return this.cookieData;
      }
    } catch (error) {
      console.error('Failed to load cookie from localStorage:', error);
      this.clearCookieFromStorage();
    }
    return null;
  }

  /**
   * Clear cookie data from localStorage
   */
  clearCookieFromStorage(): void {
    try {
      localStorage.removeItem(this.COOKIE_STORAGE_KEY);
      this.cookieData = null;
      console.log('Cookie cleared from localStorage');
    } catch (error) {
      console.error('Failed to clear cookie from localStorage:', error);
    }
  }

  /**
   * Check if we have a valid cookie stored
   */
  hasStoredCookie(): boolean {
    return this.cookieData !== null &&
           this.cookieData?.cookie?.value !== undefined &&
           this.cookieData?.cookie?.value !== '';
  }

}
